// removed by extract-text-webpack-plugin
module.exports = {"codeBlock":"codeBlock--2nPRx","codeSection":"codeSection--l3D_7","code":"code--2exA6"};